<mat-spinner
  *ngIf="!init"
  style="margin: auto"
  color="primary"
  diameter="24"
></mat-spinner>
<div *ngIf="init" class="edit-employee-user">
  <div class="container">
    <div class="d-flex justify-content-between">
      <h2 *ngIf="user.id > 0; else newUserTitle">
        Bewerk gebruiker: {{ user.firstName | personName : user.lastName }}
      </h2>
      <ng-template #newUserTitle>
        <h2>Nieuwe gebruiker</h2>
      </ng-template>
      <button class="btn btn-main btn-back" type="button" (click)="close()">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
    <div class="upper-space d-flex">
      <employee-profile-picture
        [user]="user"
        (offlineProfilePictureSet)="offlineProfilePictureChanged($event)"
      ></employee-profile-picture>
      <div *ngIf="user.id != null && user.id > 0" class="flex-to-bottom">
        <div class="resend-button">
          <button class="button btn" type="button" (click)="resendLoginEmail()">
            Login mail opnieuw versturen
          </button>
        </div>
      </div>
      <div *ngIf="user.lastLogin != null" class="flex-to-bottom">
        <div class="strong last-login-label">
          Laatst ingelogd op {{ user.lastLogin | slice : 0 : 11 }}
        </div>
      </div>
    </div>

    <hr />

    <div class="d-flex">
      <mat-form-field class="regular-field" appearance="outline">
        <mat-label>Voornaam</mat-label>
        <input matInput [(ngModel)]="user.firstName" />
      </mat-form-field>
      <mat-form-field class="left-space regular-field" appearance="outline">
        <mat-label>Achternaam</mat-label>
        <input matInput [(ngModel)]="user.lastName" />
      </mat-form-field>
    </div>
    <div class="small-upper-space d-flex">
      <mat-form-field class="regular-field" appearance="outline">
        <mat-label>Tel nr</mat-label>
        <input
          matInput
          [ngModel]="user.phone | asFormatPhoneNumber"
          (ngModelChange)="phoneChanged($event)"
        />
      </mat-form-field>
      <mat-form-field class="left-space regular-field" appearance="outline">
        <mat-label>GSM</mat-label>
        <input
          matInput
          [ngModel]="user.mobilePhoneNumber | asFormatPhoneNumber"
          (ngModelChange)="mobilePhoneNumberChanged($event)"
        />
      </mat-form-field>
      <mat-form-field class="left-space regular-field" appearance="outline">
        <mat-label>Emailadres</mat-label>
        <input
          matInput
          type="email"
          [(ngModel)]="user.email"
          email
          #emailRef="ngModel"
        />
      </mat-form-field>
    </div>
    <div class="small-upper-space">
      <mat-form-field class="wide-field" appearance="outline">
        <mat-label>Thuisadres</mat-label>
        <input matInput [(ngModel)]="user.employee.address.line1" />
      </mat-form-field>
    </div>
    <div class="small-upper-space d-flex">
      <mat-form-field class="regular-field" appearance="outline">
        <mat-label>Postcode</mat-label>
        <input matInput [(ngModel)]="user.employee.address.postalCode" />
      </mat-form-field>
      <mat-form-field class="left-space regular-field" appearance="outline">
        <mat-label>Gemeente</mat-label>
        <input matInput [(ngModel)]="user.employee.address.city" />
      </mat-form-field>
    </div>
    <div class="small-upper-space">
      <mat-form-field appearance="outline">
        <mat-label>Geboortedatum</mat-label>
        <input
          matInput
          [matDatepicker]="dateOfBirthPicker"
          placeholder="Selecteer een datum"
          [(ngModel)]="user.employee.dateOfBirth"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="dateOfBirthPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #dateOfBirthPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="small-upper-space">
      <mat-form-field class="full-width-field" appearance="outline">
        <mat-label>Extra info</mat-label>
        <textarea
          matInput
          [(ngModel)]="user.employee.extraInfo"
          cdkTextareaAutosize
        >
        </textarea>
      </mat-form-field>
    </div>

    <hr />

    <div>
      <span class="section-label">Gebruikersrollen</span>
    </div>

    <div class="d-flex upper-space">
      <div class="user-roles-column">
        <div class="flex-column">
          <mat-checkbox
            [(ngModel)]="adminChecked"
            (ngModelChange)="adminCheckedChanged($event)"
            >Admin</mat-checkbox
          >
          <mat-checkbox [(ngModel)]="user.employee.active">Actief</mat-checkbox>
        </div>
        <div class="more-upper-space">
          <div class="section-label">Filiaal</div>
          <mat-form-field
            class="upper-space regular-field"
            appearance="outline"
          >
            <mat-select
              matInput
              placeholder="Maak een keuze"
              [(ngModel)]="user.employee.branch"
              [compareWith]="compareEntities"
            >
              <mat-option *ngFor="let option of branchChoices" [value]="option">
                {{ option.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="small-upper-space">
          <div class="section-label">Aantal jobs</div>
          <mat-form-field class="regular-field" appearance="outline">
            <mat-label>Aantal jobs</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="user.employee.numberOfJobs"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="user-roles-column">
        <div class="in-the-middle">
          <div class="flex-column">
            <mat-checkbox
              *ngFor="let option of employeeTypeOptions"
              [(ngModel)]="option.checked"
              >{{ option.label }}</mat-checkbox
            >
          </div>
        </div>
      </div>
      <div class="user-roles-column"></div>
    </div>
  </div>
</div>
<div *ngIf="init" class="upper-space container">
  <div class="float-right">
    <button
      *ngIf="!saving"
      class="button btn"
      type="button"
      (click)="submitUser()"
    >
      Opslaan
    </button>
    <mat-spinner
      *ngIf="saving"
      class="top-space"
      color="primary"
      diameter="24"
    ></mat-spinner>
  </div>
</div>
